import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { CheckCircle2, ShieldCheck } from 'lucide-react';

export default function Fee() {
  const points = [
    'All 10 phases + 2 end-to-end industry projects',
    'Lifetime access to recordings & resources',
    'Unlimited AI-powered mock interviews',
    'Structured placement assistance',
  ];

  return (
    <section id="fees" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal><SectionLabel>Course Fee</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[68px] leading-[1.02] font-semibold text-[#293891] mt-6 max-w-4xl">
            One honest price. <span className="text-[#E63329]">No fake discounts.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-[#293891]/75">
            No inflated MRPs. No countdown tricks. No manufactured urgency. Just the real fee for a live, mentor-led program built to make you career-ready in Data Science &amp; AI.
          </p>
        </Reveal>

        <div className="mt-14 max-w-3xl">
          <div className="relative overflow-hidden rounded-3xl p-8 lg:p-12 border border-[#293891]/15 bg-gradient-to-br from-[#F4F5FB] to-white">
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#E63329]/10 blur-3xl"/>
            <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[#293891]/10 blur-3xl"/>

            <div className="relative">
              <div className="inline-flex items-center gap-2 border border-[#293891]/20 bg-white/70 backdrop-blur-sm rounded-full px-3.5 py-1.5 text-[11px] tracking-widest uppercase text-[#293891] font-semibold">
                <ShieldCheck size={13} className="text-[#E63329]"/> Transparent Pricing
              </div>

              <div className="mt-8 text-[12px] tracking-widest uppercase font-semibold text-[#293891]/70">Course Fee</div>
              <div className="flex items-end gap-4 mt-2 flex-wrap">
                <div className="font-display font-semibold text-[#E63329] text-[74px] sm:text-[96px] leading-none">₹50,000/-</div>
                <div className="pb-3 text-[12.5px] text-[#293891]/65">including GST</div>
              </div>

              <ul className="mt-10 grid sm:grid-cols-2 gap-y-3 gap-x-4">
                {points.map(p => (
                  <li key={p} className="flex items-start gap-2">
                    <CheckCircle2 className="text-[#E63329] shrink-0 mt-0.5" size={18}/>
                    <span className="text-[13px] text-[#293891]/80">{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-10 text-[13px] text-[#293891]/75 max-w-md leading-relaxed">Contact your relationship manager to complete the enrollment procedures.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
